import {configJson, getHttp} from "@/api/config/http-configs";

// 硬件设备加入
export const addDevice = (deviceInfo) => {
    let url = `/mobile/device/connect`
    return getHttp().post(url, deviceInfo, configJson)
}

// 免授权码重连：凭绑定登记的硬件指纹补发 token（重装/重启后免授权）
export const reconnectDevice = (deviceInfo) => {
    let url = `/mobile/device/reconnect`
    return getHttp().post(url, deviceInfo, configJson)
}

// 终端解绑：释放后台上绑定本设备的授权码（BOUND→ASSIGNED，可重新分配），设备记录置 INVALID。
// 须在清除本地 token 之前调用（依赖 TERMINAL token 鉴权）。
export const unbindDevice = () => {
    let url = `/mobile/device/unbind`
    return getHttp().post(url, {}, configJson)
}

export const sentHeartbeat = (deviceId) => {
    let url = `/mobile/device/heartbeat/${deviceId}`
    return getHttp().get(url)
}

export const getDeviceAreaInfo = (areaId) => {
    let url = `/mobile/device/area/list/one/${areaId}`
    return getHttp().get(url)
}